import React from 'react';
import PropTypes from 'prop-types';
import Radio from './Radio';
import QuickUpdatableComponent from './QuickUpdatableComponent';

class YesNoRadio extends QuickUpdatableComponent {
    render() {
        const {field, help, label, disabled, loading} = this.props;
        const options = [
            {
                label: 'Yes'
            },
            {
                label: 'No'
            }
        ];

        return (
            <Radio {...this.props} options={options} />);
    }
}

YesNoRadio.propTypes = {
    field: PropTypes.object.isRequired
}

export default YesNoRadio;
